var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"shopandfly@163b279119d3132d755dbecc843492f5612314ba"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

const Sentry = require('@sentry/nextjs');

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ENV = process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV;

if (/prod/gi.test(SENTRY_ENV)) {
  Sentry.init({
    dsn: SENTRY_DSN,
    beforeSend(event) {
      if (event.level === 'error') {
        event.sampleRate = 0.5;
      } else {
        event.sampleRate = 0.01;
      }
      return event;
    },
    tracesSampleRate: 0.01,
    environment: SENTRY_ENV,
    defaultIntegrations: false,
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.01,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 0.5,

    // for Deeply Nested objects are being serialised
    normalizeDepth: 11,

    // Ignore errors based on a regular expression
    ignoreTransactions: [/ApiError/, /healthcheck/],

    // Ignore 404 notFound() framework digest errors
    ignoreErrors: [/^NEXT_HTTP_ERROR_FALLBACK;404$/],

    integrations: [
      new Sentry.Replay({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}
